import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import DateRangeIcon from '@mui/icons-material/DateRange';
import './StyledDateTimePicker.css';

/**
 * StyledDateTimePicker — Design-system wrapper around react-datetime-picker.
 *
 * Gives the date/time picker the same label/error/required treatment as
 * StyledInput / StyledSelect so forms stay consistent. All react-datetime-picker
 * props are passed through.
 *
 * @param {string} label
 * @param {string} error
 * @param {boolean} required
 * @param {Date} value
 * @param {function} onChange
 * @param {string} format - date-fns style format (default 'dd-MM-yyyy HH:mm')
 */
const StyledDateTimePicker = ({
  label,
  error,
  required = false,
  value,
  onChange,
  format = 'dd-MM-yyyy HH:mm',
  className = '',
  ...props
}) => {
  const wrapperClasses = [
    'ck-datetime-wrapper',
    error && 'ck-datetime-wrapper--error',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {label && (
        <label className="ck-datetime-label">
          {label}
          {required && <span className="ck-datetime-required">*</span>}
        </label>
      )}
      <div className="ck-datetime-field">
        <DateTimePicker
          value={value}
          onChange={onChange}
          format={format}
          disableClock
          calendarIcon={<DateRangeIcon />}
          {...props}
        />
      </div>
      {error && <span className="ck-datetime-error">{error}</span>}
    </div>
  );
};

export default StyledDateTimePicker;
